import { AppConfig } from "../../AppConfig";
export const DetectRolld = {
  methods: {
    isRolldStore: function () {
      var rolldBuildVar = AppConfig.isRolldStore;
      if (rolldBuildVar != "true" && rolldBuildVar != "false") {
        rolldBuildVar = "false";
      }
      // Todo enable this when Rolld is ready
      var isRolld =
        process.env.NODE_ENV === "production" ? rolldBuildVar : "false";
      return isRolld === "true" ? true : false;
    },
  },
};
